export const statuses = [
	{ text: 'Airing' },
	{
		text: 'Upcoming',
	},
	{
		text: 'TV',
	},
	{
		text: 'Movie',
	},
	{
		text: 'Ova',
	},
	{
		text: 'Special',
	},
];
